import React from 'react';
import { FormattedMessage } from 'react-intl';
import { AsyncNotificationStatus } from '../../../utils/hooks/useNotificator/useNotificator.types';
import { DataHook } from './components';
import { GenericNotification } from './GenericNotification';

export const emptyTrashNotification =
  () =>
  ({ notification }) =>
    (
      <DataHook dataHook="notification.empty-trash" notification={notification}>
        <GenericNotification
          notification={notification}
          text={
            <FormattedMessage
              id={
                notification.status === AsyncNotificationStatus.Pending
                  ? 'files-manager.empty-trash-notification.pending'
                  : 'files-manager.empty-trash-notification.done'
              }
            />
          }
        />
      </DataHook>
    );
